import React from 'react';
import './Button.css';
/**
 * Renders the Button component.
 *
 * @param {React.ReactNode} children - the button's text.
 * @param {string} [className] - the CSS classes.
 * @param {React.MouseEventHandler<HTMLButtonElement>} [onClick] - onClick handler.
 * @param {string} [style] - the CSS default style 'primary' | 'secondary'
 * @param {string} role - the html role for button 'button' | 'submit'
 * @param {boolean} [disabled] - disable button
 *
 * @example
 * <Button
 *  onClick={e => e}
 *  className='a6y-react-auth-button'
 *  style='primary'
 *  role='button'
 * >
 *  Click me
 * </Button
 */
var Button = function (_a) {
    var _b;
    var _c = _a.role, role = _c === void 0 ? 'button' : _c, children = _a.children, className = _a.className, onClick = _a.onClick, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.style, style = _e === void 0 ? 'primary' : _e;
    var classNames = require('classnames');
    var btnClass = classNames((_b = {},
        _b["a6y-react-auth__button a6y-react-auth__button--" + style] = style
            ? true
            : false,
        _b));
    return (React.createElement("button", { disabled: disabled, onClick: onClick, className: className && className.length > 0 ? className : btnClass, type: role }, children));
};
export default Button;
//# sourceMappingURL=Button.js.map